export const WIDGET_ID = 'SCRATCH_OF_THE_DAY';
export const WIDGET_MODAL = 'widget-modal-SOTD';
export const SPINNER_ID = 'sotd-spinner';
export const SPINNER_WRAPPER_ID = 'sotd-spinner-wrapper';
export const IFRAME_SOURCE_ID = 'scratch-of-the-day';
export const MESSAGE_EVENT_TYPE = 'message';
export const IFRAME_ACTION_NAVIGATE = 'navigate';
export const IFRAME_ACTION_CLOSE = 'close';
export const IFRAME_ACTION_ADDTOSLIP = 'addToSlip';
export const IFRAME_ACTION_ANALYTICS = 'analytics';
export const EVENT_PAGE = 'event';
export const HOME_PAGE = 'home';
export const SPORTCALLER_ANALYTICS_EVENT = 'sport_caller';
export const PAGEVIEW_ANALYTICS_EVENT = 'pageview';
export const MODAL = 'xs-modal';
export const MODAL_OPEN = 'xs-modal--open';
export const TOOLBAR = 'toolbar';
export const HEADER = 'header';
